import { useEffect, useState } from "react";
import SharedDiv from "../../Components/SharedDiv/SharedDiv"
import InformationAboutApplication from "../../PagesReportStage/InformationAboutApplication"
import { useDispatch, useSelector } from "react-redux";
import './style.css'
import ReportStages from "../../PagesReportStage/ReportStages";
import ObjectivesProject from "../../PagesReportStage/ObjectivesProject";
import ExpectedObjectivesForReport from "../../PagesReportStage/ExpectedObjectivesForReport";
import { ValidateWorkFlow, WorkFlowReport } from "../../Redux/Reducers/ReportStage/WorkFlowReport";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../Services/Account/EncryptionParams";
import { GetReportByAppGuid } from "../../Redux/Reducers/ReportStage/Report";
import PopupAHSF from "../../Components/PopupAHSF";

const PrepareProgressReport = () => {
    const [jsonData, setJsonData] = useState(); // State to store the data loaded from the external file
    const reports = useSelector((state) => state.ReportByAppGuidReducers.ReportByApp)
    const [PopupComponentValidationViewStatus, setPopupComponentValidationViewStatus] = useState(false); // State to control whether the validation popup is visible or not
    const validationList = useSelector((state) => state.WorkFlowReducer.ValidateWorkFlow)
    const [appGuid, setAppGuid] = useState(null)
    const tokens = useParams().token
    // console.log(decryptToken(tokens),"sdlskdlskdd");

    useEffect(() => {


        if (tokens) {
            var token = decryptToken(tokens)
            console.log(token, "sdsdssssssssssssssssssssdd");

            setAppGuid(token)
            

        }

    }, [])
    const dispatch = useDispatch()
    const state = useSelector((state) => {
        return {
            jsonData: state.FetchDataJson.JsonData,
            ActiveRound: state.ApplicationInformation.ActiveRound,
            ApplicationInformation:
                state.ApplicationInformation.ApplicationInformation,
        };
    });
    useEffect(() => {
        dispatch(GetReportByAppGuid({ aI_ApplicationInformationId: appGuid }))

    }, [appGuid])

    const addPrepareProgressReport = () => {
        dispatch(WorkFlowReport({
            pR_ReportActionFlowGuid: "c2a613bc-4eaa-4508-8470-6debbe281d43",
            pR_ReportsId: reports?.
                pR_ReportsId,
            appGuid: appGuid
        }))
    }
    const closePopupComponentValidationViewStatus = () => { // Function to toggle the visibility of the validation popup
        if (PopupComponentValidationViewStatus) {
            setPopupComponentValidationViewStatus(false); // Closing the popup
        } else {
            setPopupComponentValidationViewStatus(true); // Opening the popup
        }
    };
    const validation = () => {
       
        
        let result = dispatch(ValidateWorkFlow({
            reportGuid: reports?.
                pR_ReportsId,
            applicationInformationGUID: appGuid
        }))

        if (result?.payload?.length == 0||result?.payload==undefined) {
            addPrepareProgressReport()
        } else {
            closePopupComponentValidationViewStatus()
        }
        console.log(result?.payload,"skjdksjd");
    }


    return (
        <>
            <SharedDiv
                showTitle={true}
                titleName={state.jsonData ? state.jsonData.AppInfoReportStage.nameAR : ""} // Display the translated title of the time frame information
                child={[<InformationAboutApplication />]} // Display the TimeFrameInformation component
                showButton={true}
                id_Title="PrepareProgressReport"
            />
            <SharedDiv
                showTitle={true}
                titleName={state.jsonData ? state.jsonData.RS_ReportStages.nameAR : ""} // Display the translated title of the time frame information
                child={[<ReportStages />]} // Display the TimeFrameInformation component
                showButton={true}
                id_Title="PrepareProgressReport"
            />
            <SharedDiv
                showTitle={true}
                titleName={state.jsonData ? state.jsonData.RS_ObjectivesProject.nameAR : ""} // Display the translated title of the time frame information
                child={[<ObjectivesProject />]} // Display the TimeFrameInformation component
                showButton={true}
                id_Title="PrepareProgressReport"
            />
            <SharedDiv
                showTitle={true}
                titleName={state.jsonData ? state.jsonData.ExpectedAchievementsObjectives.nameAR : ""} // Display the translated title of the time frame information
                child={[<ExpectedObjectivesForReport />]} // Display the TimeFrameInformation component
                showButton={true}
                id_Title="PrepareProgressReport"
            />

            <div className='containerButton'>
                <button onClick={validation} className="custom-button">
                    تقديم
                </button>
            </div>


            <PopupAHSF
                title={"يرجى تعبئة الحقول المطلوبة"} // Title for the validation popup
                componentBody={
                    <>
                        {validationList &&
                            validationList.map((ele, ind) => {
                                return (
                                    <>
                                        <p>{ele.fieldsName} {ele.message}</p>
                                        <span>{ele.
                                            code
                                        } </span>
                                    </>
                                );
                            })}
                    </>
                }
                maxWidth="700px"
                maxHeight="800px"
                isPopupOpenStatus={PopupComponentValidationViewStatus} // Popup open status
                isPopupOpenFunction={closePopupComponentValidationViewStatus} // Function to close the popup
            />
        </>)
}

export default PrepareProgressReport